import React, { useState, useImperativeHandle, forwardRef, memo } from 'react';
import { Modal, Button } from 'antd';
import './index.less';
import { ReactComponent as ArrowComp } from '../../../../assets/icons/arrow-brand.svg';
import Utils from '../../../../utils';
import sendGaEvent from '@/ga';
import { useDispatch, useSelector } from 'react-redux';
import actions from '../../../../redux/action';
import screenPurchaseData from '../../../../constants/screenPurchase';
import axios from 'axios';
import V1cart from '@/utils/V1cart';
import { api_config } from '@/constants/api';
import { requsetGetSubscription } from '@/api/apis';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
let apiUrlV2 = api_config.API_V2_URL;
const ScreenPurchase = forwardRef((props, ref) => {
  const { t } = useTranslation(['screenRecorder']);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [label, setLabel] = useState(null);
  const [select, setSelect] = useState('week');
  const [purchaseLoading, setPurchaseLoading] = useState(false);
  const reducerData = useSelector((state) => state.common);
  const planGa = { week: 'Weekly', month: 'Monthly', year: 'Yearly' };
  const timePlan = [t('Week'), t('Month'), t('Year')];
  const dispatch = useDispatch();

  useEffect(() => {
    if (isModalOpen) {
      sendGaEvent({
        category: 'UpgradePrompShow',
        action: '06SR_UpgradePrompShow',
        label: 'Null',
      });
    }
  }, [isModalOpen]);

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const changeSelect = (value) => {
    setSelect(value);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    if (!Cookies.get('authorization')) return;
    requsetGetSubscription({
      from_product: 11,
    })
      .then((res) => {
        if (res.code === 200) {
          dispatch(actions.onSubscriptionChange(res.data.subscription));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getPurchase = () => {
    console.log('周月年', select);
    // week | month | year
    if (select === 'week') {
      window.sessionStorage.cycle = '1';
    }
    if (select === 'month') {
      window.sessionStorage.cycle = '2';
    }
    if (select === 'year') {
      window.sessionStorage.cycle = '3';
    }

    // return
    sendGaEvent({
      category: 'AddToCart',
      action: 'ScreenRecorder_AddToCart',
      label: `${label}_${planGa[select]}_${Utils.systemCheck()}`,
    });
    sendGaEvent({
      category: 'BuyClick',
      action: '06SR_BuyClick',
      label: 'Null',
    });
    if (!Cookies.get('authorization')) {
      dispatch(
        actions.onSignUpModal({
          visible: true,
        })
      );
      return;
    }
    sendGaEvent({
      category: 'BuyNow',
      action: '06SR_BuyNow',
      label: 'Null',
    });
    setPurchaseLoading(true);
    let site = Utils.getLanguage();
    site = site === 'tk' ? 'tr' : site === 'inn' ? 'in' : site;

    const formData = new FormData();
    formData.append('plan', select);
    formData.append('site', site);
    formData.append('FromProduct ', 'screen-recorder');
    axios({
      url: apiUrlV2 + 'product-check-out',
      method: 'POST',
      headers: { authorization: reducerData.authorization },
      params: { plan: select, site: site, FromProduct: 'screen-recorder' },
    })
      .then((res) => {
        console.log(res);
        if (res.data.code === 200) {
          //轮询监听用户购买
          dispatch(actions.onPayBill(true));

          //购物车地址
          let cartUrl = res.data.data.cart_url;
          cartUrl = V1cart(cartUrl);
          // return

          window.open(cartUrl, '_blank');
        }
        setPurchaseLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const purchaseData = [
    { content: t('NoRecordNumLimit') },
    { content: t('NoRecordLimit') },
    { content: t('DownloadVideoMP4') },
  ];
  useImperativeHandle(ref, () => ({
    setIsModalOpen,
    setLabel,
  }));

  return (
    <>
      <Modal
        className='screenModal'
        centered
        visible={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        maskClosable={false}
        width={1000}
      >
        <div className='screenPurchaseBody'>
          <div className='screenPurchaseLeft'>
            <div className='screenPurchaseTitle'>
              {t('OnlineScreen')} <span className='pro'>Pro</span>
            </div>
            {purchaseData.map((item, index) => {
              return (
                <div className='purchaseList' key={'purchaseList' + index}>
                  <ArrowComp className='arrowComp' /> {item.content}
                </div>
              );
            })}
          </div>
          <div className='screenPurchaseRight'>
            {Array.from(screenPurchaseData).map(([value, item], index) => {
              return (
                <div
                  key={'screenPurchaseData' + index}
                  onClick={() => changeSelect(item.key)}
                  className={`priceCard ${select === item.key ? 'select' : ''}`}
                >
                  <div className='planText'>{timePlan[index]}</div>
                  <div className='priceGroup'>
                    <div className='price'>
                      {item.perWeek}
                      <span className='priceTime'>/{timePlan[0]}</span>
                    </div>
                    {select === item.key && item.key !== 'week' ? (
                      <div className='totalPrice'>
                        {item.price}/
                        {item.key === 'month'
                          ? t('BilledMonthly')
                          : t('BilledAnnually')}
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                  {item.key !== 'week' ? (
                    <div className='save'>
                      {' '}
                      {item.key === 'month' ? t('MonthOff') : t('YearOff')}
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              );
            })}

            <Button
              onClick={() => getPurchase()}
              loading={purchaseLoading}
              className='screenBuyNow'
            >
              {t('BuyNow')}
            </Button>
            {!Cookies.get('authorization') ? (
              <div
                className='screenLoginText'
                onClick={() => {
                  dispatch(
                    actions.onSignUpModal({
                      visible: true,
                    })
                  );
                }}
              >
                {t('AlreadyHaveAccount')} {t('LoginNow')}
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
      </Modal>
    </>
  );
});
export default ScreenPurchase;
